import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

const menus = [
  { id: 1, title: "Whitepaper", link: "https://atom-foundation.gitbook.io/atom-foundation-docs" },
  { id: 2, title: "Join Whitelist", link: "https://whitelist.atomfoundation.io/" },
  { id: 3, title: "Tokenomics", link: "https://atom-foundation.gitbook.io/atom-foundation-docs/tokenomics-and-distribution" },
  { id: 4, title: "Visual Network", link: "https://dashboard.atomfoundation.io/" },
  { id: 5, title: "Dex Alpha", link: "https://dex.atomfoundation.io/" },
];

const MobileMenu: React.FC = () => {
  const handleClick = () => window.scrollTo(0, 0);

  return (
    <>
      <ul className="responsivemenu">
        {menus.map((menu) => (
          <li key={menu.id}>
            {menu.link.startsWith("http") ? (
              <a href={menu.link} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
                {menu.title}
              </a>
            ) : (
              <Link to={menu.link} onClick={handleClick}>
                {menu.title}
              </Link>
            )}
          </li>
        ))}
      </ul>

    </>
  );
};

export default MobileMenu;
